export enum Events {
    PAGE_VIEW = "Page View",
    BUTTON_CLICK = "Button Click",
    FORM_SUBMITTED = "Form Submitted"
}